import React, { Component } from "react";
import "../Common/Common.css";
import PurchaseReturnsView from "./PurchaseReturnsView";
import AddPurchaseReturns from "./AddPurchaseReturns";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
var dateFormat = require("dateformat");

class PurchaseReturns extends Component {
  constructor(props) {
    super(props);
    this.paginationreset = React.createRef();
    this.state = {
      showPurchaseReturnsModal: false,
      PurchaseReturnstoSearch: "",
      returnfilter: "",
      showCreditNotesAddModel: false,
      PurchaseReturnsToShow: [],
      CreditNotesdtList: "",

      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.fetchPurchaseReturns({
      page: undefined,
      filter: this.state.returnfilter,
      searchquery: this.state.PurchaseReturnstoSearch,
    });
  }

  handleAddCreditNotes = (item) => {
    this.setState({
      showCreditNotesAddModel: true,
      CreditNotesdtList: item,
    });
  };
  closeAddCreditNotesModel = () => {
    this.setState({
      showCreditNotesAddModel: false,
    });
  };

  showPurchaseReturnsDetail = (item) => {
    this.setState(
      {
        ...this.state,
        showPurchaseReturnsModal: true,
        PurchaseReturnsToShow: item,
      },
      () => {
        this.props.ProductReturnview({
          item: this.state.PurchaseReturnsToShow,
          page: undefined,
        });
      }
    );
  };

  closePurchaseReturnsModal = () => {
    this.setState({
      ...this.state,
      showPurchaseReturnsModal: false,
    });
    this.paginationreset.current.resetitemPage();
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.pageSelected({
      page: selectedPage + 1,
      filter: this.state.returnfilter,
      searchquery: this.state.PurchaseReturnstoSearch,
    });
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  searchPurchaseReturns = (event) => {
    this.setState(
      {
        PurchaseReturnstoSearch: event.target.value,
        returnfilter: "",
        page: 0,
      },
      () => {
        this.props.fetchPurchaseReturns({
          page: undefined,
          filter: this.state.returnfilter,
          searchquery: this.state.PurchaseReturnstoSearch,
        });
      }
    );
  };

  returnfilterChange = (event) => {
    this.setState(
      {
        ...this.state,
        page: 0,
        PurchaseReturnstoSearch: "",
        returnfilter: event.target.value,
      },
      () => {
        this.props.fetchPurchaseReturns({
          page: undefined,
          searchquery: this.state.PurchaseReturnstoSearch,
          filter: this.state.returnfilter,
        });
      }
    );
  };

  renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  addcreditTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Add Credit Note
    </Tooltip>
  );

  render() {
    const {
      ProductreturnsDetails,
      ProductreturnsCount,
      ProductReturnDtls,
      ItemCount,
      itempageSelected,
      returnrejected,
      returnaccept,
      returnacceptOne,
      returnrejectedOne,
      updatePurchaseOrderTotals,
      pdfreturnFullData,
    } = this.props;
    const {
      page,
      perPage,
      PurchaseReturnstoSearch,
      showPurchaseReturnsModal,
      PurchaseReturnsToShow,
      returnfilter,
    } = this.state;
    const {
      searchPurchaseReturns,
      closePurchaseReturnsModal,
      handlePageClick,
      showPurchaseReturnsDetail,
      itemsPageClick,
      showCreditNotesAddModel,
      returnfilterChange,
    } = this;

    const count = ProductreturnsCount;
    let p = page + 1;
    let PurchaseReturnspageCount = Math.ceil(count / perPage);     
    
    
    return (
      <div className="salesreturndiv">
        <Card>
          <div className="salesheader">
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <h5 className="tablecardtitle">Sales Returns</h5>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon" />
                    <input
                      type="text"
                      placeholder="Return ID/Org Name"
                      value={PurchaseReturnstoSearch}
                      onChange={searchPurchaseReturns}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={returnfilter}
                    onChange={returnfilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="accepted">Accepted</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {" "}
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>

          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Return ID</th>
                    <th>Organization Name</th>
                    <th>Claim Amount</th>
                    <th>Approved Amount</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody className="tableBody">
                  {ProductreturnsDetails &&
                    ProductreturnsDetails.map((item, i) => (
                      <tr key={i}>
                        <th scope="row">{10 * (p - 1) + i + 1}</th>
                        <td className="cmn_Cap">
                          {item !== null && item.orderNo ? item.orderNo : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.chmstDtls
                            ? item.chmstDtls.name
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderDetail ? item.orderDetail.claimAmount : 0}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.totalApprovedAmount ? item.totalApprovedAmount : 0}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy")
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.status === "created" ? (
                            <span className="badge badge-primary">
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          ) : item !== null && item.status === "accepted" ? (
                            <span className="badge badge-success ">
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          ) : (
                            <span className="badge badge-danger">
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          )}
                        </td>

                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  showPurchaseReturnsDetail({ item: item })
                                }
                              />
                            </OverlayTrigger>

                            {item !== null &&
                            item.status === "accepted" &&
                            item.hasCreated === false ? (
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.addcreditTooltip}
                              >
                                <i
                                  className="fa fa-upload"
                                  style={{
                                    paddingLeft: 10,
                                    fontSize: "15px",
                                  }}
                                  onClick={() =>
                                    this.handleAddCreditNotes(item)
                                  }
                                />
                              </OverlayTrigger>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <PurchaseReturnsView
                ref={this.paginationreset}
                show={showPurchaseReturnsModal}
                close={closePurchaseReturnsModal}
                PurchaseReturnsToShow={PurchaseReturnsToShow}
                ProductReturnDtls={ProductReturnDtls}
                ItemCount={ItemCount}
                itemsPageClick={itemsPageClick}
                itempageSelected={itempageSelected}
                returnrejected={returnrejected}
                returnaccept={returnaccept}
                returnacceptOne={returnacceptOne}
                returnrejectedOne={returnrejectedOne}
                updatePurchaseOrderTotals={updatePurchaseOrderTotals}
                pdfreturnFullData={pdfreturnFullData}
              />
              <AddPurchaseReturns
                showCreditNotesAddModel={this.state.showCreditNotesAddModel}
                closeAddCreditNotesModel={this.closeAddCreditNotesModel}
                AddCreditNotes={this.props.AddCreditNotes}
                CreditNotesdtList={this.state.CreditNotesdtList}
                CreditNotesAdd={this.props.CreditNotesAdd}
              />
              {(ProductreturnsDetails === undefined ||
                (ProductreturnsDetails && ProductreturnsCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Returns Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {PurchaseReturnspageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={PurchaseReturnspageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default PurchaseReturns;
